import { useCallback, useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import { WhatDidYouThinkText, StyledIconButton, MainContainer } from './components.styles';

const LessonStarRating = ({ userRating, onClick, maxRating }) => {
  const [rating, setRating] = useState(userRating);

  useEffect(() => {
    setRating(userRating);
  }, [userRating]);

  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down('sm'));

  const stars = Array.from(Array(maxRating).keys());

  const click = useCallback((selected) => {
    setRating(selected);
    if (onClick) onClick(selected);
  }, [setRating, onClick]);

  return (
    <MainContainer>
      <Grid container alignItems="center" direction={isMobile ? 'column' : 'row'} columnSpacing={1}>
        <Grid item>
          <WhatDidYouThinkText size="lg" bold>What did you think?</WhatDidYouThinkText>
        </Grid>
        <Grid item>
          {
              stars.map((key) => (
                <StyledIconButton
                  key={key}
                  onClick={() => click(key + 1)}
                  size="large"
                >
                  {
                      (key + 1) <= rating ? (
                        <StarRoundedIcon data-testid="filled-rounded-star-icon" fontSize="large" />
                      ) : (
                        <StarBorderRoundedIcon data-testid="bordered-rounded-star-icon" fontSize="large" />
                      )
                    }
                </StyledIconButton>
              ))
            }
        </Grid>
      </Grid>
    </MainContainer>
  );
};

LessonStarRating.propTypes = {
  userRating: PropTypes.number,
  onClick: PropTypes.func,
  maxRating: PropTypes.number
};

LessonStarRating.defaultProps = {
  userRating: 0,
  maxRating: 5
};

export default LessonStarRating;
